import { SvgIcon } from "@mui/material";

export function Plus(props) {
    return (
        <SvgIcon {...props}>
            <path d="M11.0001 4.5C11.0001 3.94772 11.4478 3.5 12.0001 3.5C12.5524 3.5 13.0001 3.94772 13.0001 4.5V19.5C13.0001 20.0523 12.5524 20.5 12.0001 20.5C11.4478 20.5 11.0001 20.0523 11.0001 19.5V4.5Z" />
            <path d="M19.5 11C20.0523 11 20.5 11.4477 20.5 12C20.5 12.5523 20.0523 13 19.5 13H4.5C3.94772 13 3.5 12.5523 3.5 12C3.5 11.4477 3.94772 11 4.5 11L19.5 11Z" />
        </SvgIcon>
    );
}
